import { createGlobalStyle } from "styled-components";

import lato300 from "../assets/fonts/Lato-Thin.woff";
import lato400 from "../assets/fonts/Lato-Regular.woff";
import lato500 from "../assets/fonts/Lato-Medium.woff";
import lato700 from "../assets/fonts/Lato-Bold.woff";

const GlobalStyles = createGlobalStyle`
  :root {
    --black: #000000;
    --greymi: #ddd;
    --litegreen: #9CB783;
    --green: #4D7853;
    --greenrgb: 77, 120, 83;
    --darkgreen: #425E4B;
    --orange: #ff8800;
    --offwhite: #c9c9c9;
    --offwhitergba: 242, 242, 242;
    --white: #fff;
    --purple: #6750A4;
    --gray: #636363;
  }
  /* Lato-300 */
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 300;
    src: url(${lato300});
  }
  /* Lato-400 */
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    src: url(${lato400});
  }
  /* Lato-500 */
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 500;
    src: url(${lato500});
  }
  /* Lato-700 */
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    src: url(${lato700});
  }

  html {
    background-color:rgba(255, 255, 255, 0.253);
    background-size: 810px;
    background-attachment: fixed;
    font-family: 'Lato';
    font-size: 10px;
    color: var(--black);
    scroll-behavior: smooth;
    box-sizing: border-box !important;
    background; #555;
    margin: 0;
  }
  
  *, *::before, *::after {
    box-sizing: border-box;
    backgground: #555;
  } 

  body {
    font-size: 1.6rem;
    scroll-behavior: smooth;
    background; #555;
    height: 100vh;
    margin: 0;
  }

  /* Scrollbar Styles */
  body::-webkit-scrollbar {
    width: 9px;
  }
  html {
    scrollbar-width: thin;
    scrollbar-color: var(--red) var(--white);
    background: #111;
  }
  body::-webkit-scrollbar-track {
    background: var(--white);
  }
  body::-webkit-scrollbar-thumb {
    background-color: var(--red) ;
    border-radius: 6px;
    border: 3px solid var(--white);
  }

  h1, h2, h3, h4, h5, h6 {
    color: var(---black)
  }

  img {
    max-width: 100%;
  }

  a {
    text-decoration: none;
    transition: opacity 0.2s ease-out;
    color: var(--black);
    font-weight: 500;
  }
  a:hover {
    opacity: 0.69;
    color: var(--white) !important;
  }

  ul {
    margin: 0 !important;
    padding: 0;
    list-style: none;
  }
  .layout {
    background-image: url(data:image/svg+xml;base64,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);
    background-size: cover;
    /* padding: 90px 12px 120px; */
    background-position: right;
    min-height: 100vh;
    margin: 0;
    overflow-y: auto; 
    overflow-x: hidden;
  }

  .container {
    max-width: 1340px;
    margin: auto;
    padding: 90px 9px 120px;
  }
  .ant-btn-primary {
    background-color: var(--white) !important;
    border-color: var(--white) !important  ;
  }

  .gallery_thumb {
    cursor: pointer;
    transition: transform .3s ease-in-out;
  }
  .gallery_thumb:hover {
    opacity: .9;
    transform: scale(1.01);
  }

  
.contact {
  display: flex;
  width: 100vw;
  max-width: 100vw;
  height: 69vh;
  margin-top: 60px;
  padding: 0;
  justify-content: space-between;
  align-items: center;
  border-radius: 0 9px 6px 0;
  height: calc(100vh - 60px);
  position: relative;
}

.contact_links {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 69%;
  height: 100%;
  padding: 6rem 0 19rem;
  color: var(--offwhite);
}
.contact_links--cover {
  flex-direction: row;
  height: auto;
}
.contact_link {
  width: 13rem;
  height: 6rem;
  /* background: rgba(0, 0, 0, 0.89); */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
  filter: invert(89%);
  opacity: .5;
}

.contact_link--ra {
  background-image: url(data:image/svg+xml;base64,ICA8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmVyc2lvbj0iMS4xIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sbnM6c3ZnanM9Imh0dHA6Ly9zdmdqcy5kZXYvc3ZnanMiICB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgODMgNDAiIGFyaWEtbGFiZWw9IlJBIGxvZ28iPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiI+PC9wYXRoPjxwYXRoIGQ9Ik04Mi4wOTIgMzIuMDE4Yy41NTYtLjUzMy45MDgtMS4yOC45MDgtMi4xMTMgMC0uODAyLS4zOC0xLjUyMy0uOS0yLjA1MUw1OC42NjUgNC4zbC03LjA3MyA3LjExIDE4LjQ1IDE4LjU0M2gtMjYuMTRjLTEuMjc4LS4wMzgtMi4yOS0uNDY5LTMuMTQ3LTEuMzA0bC0xMS43My0xMS43ODhhNi44MjggNi44MjggMCAwMC00LjY4OS0xLjg4OGwtLjAxNy4wMDFIMTAuMDA0di00LjkyaDE0LjgyNWMyLjkzOC4wMDIgNS41NTkgMS4yMSA3LjQ4IDMuMTVsOC43NDkgOC43OTMgNy4wNzMtNy4xMS04LjkyLTguOTYzQzM1LjQ4NSAyLjIzNCAzMC40NSAwIDI0LjgwNSAwSDB2MjUuMDI3aDIwLjk3OHYuMDAyYTQuOTE5IDQuOTE5IDAgMDEzLjQ4NiAxLjQ4TDM1Ljk1IDM4LjA1M0E2Ljc0IDYuNzQgMCAwMDQwLjQ0OSA0MGgzMS43MzNhNC45MTEgNC45MTEgMCAwMDMuNDIzLTEuNDVsNi40OTEtNi41MjQtLjAwNC0uMDA4IiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvcGF0aD48L2c+PC9zdmc+);
}
.contact_link--inst {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MDAiIGhlaWdodD0iODAwIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxwYXRoIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTUuODcuMTJDNC4yNC4yIDIuODMuNiAxLjY5IDEuNzIuNTUgMi44OC4xNiA0LjMuMSA1LjljLS4wNSAxLS4zMiA4LjYuNDUgMTAuNTlhNS4wNCA1LjA0IDAgMCAwIDIuOTEgMi45IDcuMyA3LjMgMCAwIDAgMi40Mi40NmM4Ljg2LjQgMTIuMTUuMTkgMTMuNTMtMy4zNi4yNS0uNjMuNDItMS4zNS40Ni0yLjQxLjQtOC44OC0uMDYtMTAuOC0xLjYtMTIuMzVDMTcuMDIuNSAxNS41OC0uMzIgNS44Ni4xM20uMDggMTcuOTRjLS45Ny0uMDUtMS41LS4yLTEuODUtLjM0LS44OC0uMzUtMS41NC0xLTEuODktMS44OS0uNTktMS41MS0uMzktOC43LS4zNC05Ljg2LjA1LTEuMTQuMjktMi4xOCAxLjA5LTIuOTkgMS0uOTkgMi4yOC0xLjQ4IDExLjAzLTEuMDggMS4xNS4wNSAyLjE5LjI4IDMgMS4wOC45OSAxIDEuNDggMi4yOSAxLjA4IDExLjAxLS4wNC45Ny0uMiAxLjUtLjM0IDEuODQtLjkgMi4zMS0yLjk3IDIuNjMtMTEuNzggMi4yM00xNC4xIDQuNjlhMS4yIDEuMiAwIDEgMCAyLjM5IDAgMS4yIDEuMiAwIDAgMC0yLjM5IDBtLTkuMjMgNS4zYTUuMSA1LjEgMCAxIDAgMTAuMi0uMDEgNS4xIDUuMSAwIDAgMC0xMC4yIDBtMS44IDBhMy4zMSAzLjMxIDAgMSAxIDYuNjIuMDIgMy4zMSAzLjMxIDAgMCAxLTYuNjItLjAxIi8+PC9zdmc+);
  height: 8rem;
  background-position-x: center;
}
.contact_link--sc {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI4MDAiIGhlaWdodD0iODAwIiB2aWV3Qm94PSIwIDAgMzAwIDMwMCI+PHBhdGggZD0ibTE0IDIwOSAyLTEgMy0yNy0zLTI3LTItMi0xIDItMyAyNyAzIDI3IDEgMXpNMyAxOTlsMi0xIDItMTctMi0xNy0yLTEtMSAxLTIgMTcgMiAxNyAxIDF6TTI4IDE0OWwtMi0yLTEgMi0zIDMyIDMgMzEgMSAyIDItMiAzLTMxLTMtMzJ6TTM4IDIxNWwyLTIgMy0zMi0zLTMzLTItMi0yIDItMiAzMyAyIDMyIDIgMnpNNTAgMjE1YzEgMCAyIDAgMi0ybDMtMzItMy0zMS0yLTItMiAyLTIgMzEgMiAzMmMwIDIgMSAyIDIgMnpNNjcgMTgxbC0zLTUwLTItMi0yIDItMiA1MCAyIDMyYzAgMiAxIDMgMiAzczItMSAyLTNsMy0zMnpNNzQgMjE2YzIgMCAzLTEgMy0zbDItMzItMi02MmMwLTEtMS0yLTMtMmwtMiAyLTIgNjIgMiAzMmMwIDIgMSAzIDIgM3pNODcgMTExYy0yIDAtMyAyLTMgM2wtMiA2NyAyIDMyYzAgMSAxIDMgMyAzbDItMyAzLTMyLTMtNjctMi0zek05OSAyMTZjMiAwIDMtMiAzLTNsMi0zMi0yLTY5YzAtMi0xLTMtMy0zcy0zIDEtMyAzbC0yIDY5IDIgMzJjMCAxIDEgMyAzIDN6TTExMSAyMTZjMiAwIDQtMiA0LTRsMi0zMS0yLTY3YzAtMi0yLTQtNC00LTEgMC0zIDItMyA0bC0yIDY3IDIgMzFjMCAyIDIgNCAzIDR6TTEyOSAxODFsLTEtNjVjMC0yLTItMy00LTNzLTMgMS00IDNsLTEgNjUgMSAzMWMxIDIgMiA0IDQgNHM0LTIgNC00bDEtMzF6TTEzNyAyMTZjMiAwIDMtMiAzLTRsMi0zMS0yLTc3YzAtMi0xLTQtMy00cy00IDItNCA0bC0yIDc3IDIgMzFjMCAyIDIgNCA0IDR6TTE0OSA5M2MtMiAwLTQgMi00IDRsLTEgODQgMSAzMWMwIDIgMiA0IDQgNHM0LTIgNC00bDItMzEtMi04NGMwLTItMi00LTQtNHpNMTYxIDIxNmgxMDJhMzcgMzcgMCAxIDAtMTQtNzIgNjUgNjUgMCAwIDAtODktNTVjLTIgMS0zIDItMyA0djExOGMwIDMgMiA1IDQgNXoiLz48L3N2Zz4=);
  background-size: cover;
  background-position-y: center;
}


.contact_form {
  display: block;
  width: 100%;
  padding: 9.6rem;
  max-width: 1469px;
  background: var(--gray);
  background-image: url(data:image/svg+xml;base64,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);
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  border-radius: 9px 0 0 0;
}

.contact_text {
  font-size: 2.3rem;
  padding: 2rem 6rem 9rem 16rem;
  text-align: right;
  box-sizing: border-box;
}

.contact_form_input,
.contact_form_textarea {
  width: 100%;
  border-bottom: 1px solid #333;
  border-radius: 0;
  padding: 0 3px 3px 3px;
  margin-bottom: 21px;
}

.contact_form_textarea--hidden {
  display: none;
}

.contact_form_textarea label,
.contact_form_input label {
  font-size: 1.8rem;
  width: 100%;
  margin-bottom: 3px;
  font-weight: 300;
  color: var(--#333);
  text-transform: uppercase;
}

.contact_form_textarea textarea,
.contact_form_input input {
  border: none;
  outline: 0;
  width: 100%;
  padding: 3px;
  font-size: 1.8rem;
  background: transparent;
}

.contact_form_textarea textarea {
  resize: none;
  display: block;
  height: 139px;
}

.contact_form_buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 21px;
}

.contact_form_buttons button {
  border: 1px solid #333;
  border-radius: 3px;
  background: transparent;
  font-size: 2.1rem;
  margin-top: 21px;
  color: #444;
  cursor: pointer;
  padding: 6px 19px 4px;
}

.events_heading {
  font-size: 2.6rem;
  padding-bottom: .9rem;
  font-weight: 300;
  color: var(--offwhite);
  border-bottom: 1px solid var(--offwhite);
}

.visually_hidden {
  visibility: none;
  position: absolute;
}

@media screen and (max-width: 855px) {
  .contact {
    width: 100vw;
    height: calc(100vh - 60px);
    margin-top: 60px;
    flex-direction: column-reverse;
    height: auto;
  }
  .contact_form {
    padding: 21px 29px;
    border-radius: 0;
  }
  .contact_text {
    font-size: 2.1rem;
  }
  .contact_links {
    flex-direction: row;
  }

  .contact_link {
    height: 6rem;
    width: 6rem;
    margin-right: 10px;
    background-position-y: center;
  }
}

`;

export default GlobalStyles;
